export default "__VITE_ASSET__DZQq1pET__"